import getCountryFromCode from "libs/helpers/getCountryFromCode";

const getUserData = (data, language) => {
  const contact_data = [
    data?.first_name && data?.last_name
      ? `${data.first_name} ${data.last_name}`
      : undefined,
    data?.email,
    data?.phone?.code && data?.phone?.number
      ? `${getCountryFromCode(data?.phone?.code).dialling_code} ${
          data?.phone?.number
        }`
      : undefined,
  ].filter((item) => item);

  const billing = data?.billing;
  const billing_data = [
    billing?.name,
    billing?.tax?.code && billing?.tax?.number
      ? `${billing.tax.code} ${billing.tax.number}`
      : undefined,
    billing?.street,
    billing?.post_code && billing?.city
      ? `${billing.post_code} ${billing.city}`
      : undefined,
    billing?.country
      ? getCountryFromCode(billing.country)?.[
          language === "pl" ? "name_pl" : "name"
        ]
      : undefined,
  ].filter((item) => item);

  return { contact_data, billing_data };
};

export default getUserData;
